module.exports = __webpack_public_path__ + "img/face6.e76bb878.gif";